import React, { memo, useState } from 'react'
import { Container, Row, Col, Form } from 'react-bootstrap'
import { Autocomplete, Stack, Button, Tooltip, TextField, Grid, Typography, FormGroup, FormControlLabel, Checkbox } from '@mui/material'
import { motion } from 'framer-motion'
import configServ from '../../../services/config'
import { useEffect } from 'react'
import SaveIcon from '@mui/icons-material/Save';
import UpdateIcon from '@mui/icons-material/Update';
import RotateLeftIcon from '@mui/icons-material/RotateLeft';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import AlertDialog from "../../AlertDialog/AlertDialog";
import CardHeadMenu from '../CardHeadMenu/CardHeadMenu'
import { useDispatch, useSelector } from 'react-redux'
import { triggerLoader } from '../../../redux/reducers/LoaderTrigger'
import Swal from 'sweetalert2'
import RequiredLabel from '../../labels/RequiredLabel'

//FUNCTION
const CategoryCard = ({ isChanged, setIsChanged, editData, setEditData }) => {
    //#region code
    const dispatch = useDispatch();
    const { company_id } = useSelector((state) => state.GlobalVariables);
    const [formData, setFormData] = useState({
        status: true,
        isPrimary: false,
        order_number: null
    });
    const [isEdit, setIsEdit] = useState(false);
    const [validationErrors, setValidationErrors] = useState({});
    const [isCreate, setIsCreate] = useState(false);
    const [orderCount, setOrderCount] = useState(0);

    const fetchActiveCategoryCount = async () => {
        try {
            const res = await configServ.getActiveCategoryCount();
            if (res.status === 200) {
                setOrderCount(res.total);
            }
            else {
                setOrderCount(0);
            }
        }
        catch (e) {
            console.log(e);
        }
    }

    useEffect(() => {
        fetchActiveCategoryCount();
    }, []);

    useEffect(() => {
        if (Object.keys(editData).length !== 0) {
            setIsCreate(true);
        }
    }, [editData]);

    // const fetchSuperCategory = async () => {
    //     try {
    //         const result = await configServ.getSuperCategory({ "company_id": company_id });
    //         setSuperCategory(result);
    //     }
    //     catch (err) {
    //         console.log(err)
    //     }
    // }

    const handleChange = (e) => {
        const { name, value } = e.target

        //Update form data
        setFormData((state) => ({
            ...state,
            [name]: value
        }));

        // Reset the validation error when the user starts typing
        if (validationErrors[name]) {
            setValidationErrors((prevValidationError) => ({
                ...prevValidationError,
                [name]: '',
            }));
        }
    }

    const handleChangeCheckbox = (e) => {
        const { name, checked } = e.target
        setFormData((state) => ({
            ...state,
            [name]: checked
        }))
    }

    // const checkFieldsNotEmpty = () => {
    //     return (
    //         formData.categoryname !== '' && formData.categoryname !== undefined && formData.categoryname !== undefined &&
    //         formData.brand_id !== '' && formData.brand_id !== undefined && formData.brand_id !== undefined
    //     );
    // };

    const handleSubmit = async (e) => {
        try {
            e.preventDefault();

            dispatch(triggerLoader());

            const error = await handleFormValidation();
            if (error === false) {
                return false;
            }
            setValidationErrors({});

            const dataToSend = {
                ...formData,
                company_id: company_id,
            }

            if (!isEdit) {
                const res = await configServ.addCategory(dataToSend);
                if (res.status === 200) {
                    setIsChanged(!isChanged)
                    clear();
                    Swal.fire({
                        icon: 'success',
                        title: 'Success',
                        text: res.message
                    });
                }
                else if (res.status === 400) {
                    Swal.fire({
                        icon: 'warning',
                        title: 'Warning',
                        text: res.message || "Failed to create category."
                    });
                }
                else {
                    Swal.fire({
                        icon: 'error',
                        title: 'Error',
                        text: res.message || "Failed to create category."
                    });
                }
            }
            else {
                const res = await configServ.editCategory(dataToSend);
                if (res.status === 200) {
                    setIsChanged(!isChanged)
                    clear();
                    Swal.fire({
                        icon: 'success',
                        title: 'Success',
                        text: res.message
                    });
                }
                else {
                    Swal.fire({
                        icon: 'error',
                        title: 'Error',
                        text: res.message || "Failed to update category."
                    });
                }
            }
            fetchActiveCategoryCount();
        }
        catch (err) {
            console.log(err);
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: "An unexpected error has occurred."
            });
        }
        finally {
            dispatch(triggerLoader());
        }
    }

    useEffect(() => {
        if (Object.keys(editData).length !== 0) {
            setFormData(editData)
            setIsEdit(true)
            setFormData((prev) => ({
                ...prev,
                status: true
            }));
        }
    }, [editData])

    const clear = () => {
        setFormData({
            status: true,
            isPrimary: false,
            order_number: null
        });
        setValidationErrors({});
        setIsEdit(false);
        setEditData({});
    }

    const handleFormValidation = async() => {
        const errors = {}
        if (!formData.categoryname) {
            errors.categoryname = "required";
        }
        if(!formData.order_number){
            errors.order_number = "required";
        }
        setValidationErrors(errors);
        return Object.values(errors).every((error) => error === "");
    }

    const handlePopup = () => {
        setIsCreate(!isCreate);
    }

    //#endregion

    return (
        <>
            <CardHeadMenu prefix={'Na'} suffix={'Na'} title={'CATEGORY'} handlePopup={handlePopup} isEdit={isEdit} create={isCreate} />

            {isCreate &&
                <motion.div style={{ width: "100%", backgroundColor: "#e3f3fc", paddingTop: 10, paddingBottom: 10, paddingLeft: 20, paddingRight: 20, borderRadius: '10px', border: 'none' }}
                    initial={{ opacity: 0, y: 10 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.1, delay: 0.1 }}
                >
                    <Grid container alignItems="flex-end" justifyContent="flex-start" spacing={1}>
                        <Grid item xs={12} md={12} justifyContent={'flex-start'}>
                            <Typography sx={{ fontSize: '16px', fontWeight: 'bolder' }}>Category Detail</Typography>
                        </Grid>

                        <Grid item xs={12} md={3}>
                            <TextField
                                id="categoryname"
                                name="categoryname"
                                label={<RequiredLabel label={'Category'} />}
                                variant="outlined"
                                size='small'
                                fullWidth
                                sx={{ backgroundColor: 'white' }}
                                onChange={handleChange}
                                error={validationErrors.categoryname}
                                value={formData.categoryname || ''}
                            />
                        </Grid>

                        <Grid item xs={12} md={3}>
                            <TextField
                                id="description"
                                name="description"
                                label="Description"
                                variant="outlined"
                                size='small'
                                multiline
                                rows={2}
                                fullWidth
                                sx={{ backgroundColor: 'white' }}
                                onChange={handleChange}
                                value={formData.description || ''}
                            />
                        </Grid>

                        <Grid item xs={12} md={2}>
                            <FormControl fullWidth>
                                <InputLabel fullWidth size='small' error={!!validationErrors.order_number}>Order</InputLabel>
                                <Select fullWidth size='small' name='order_number'
                                    value={formData.order_number} onChange={handleChange}
                                    label='Order' sx={{ backgroundColor: 'white' }}
                                    error={!!validationErrors.order_number}
                                >
                                    {Array.from({ length: orderCount + 1 }, (_, i) => (
                                        <MenuItem key={i + 1} value={i + 1}>
                                            {i + 1}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>

                        <Grid item xs={12} md={4}>
                            <FormGroup sx={{ display: 'flex', flexDirection: 'row' }}>
                                <FormControlLabel
                                    name='status'
                                    control={<Checkbox checked={Boolean(formData.status) || false} />}
                                    onChange={handleChangeCheckbox}
                                    label="Hide/Unhide"
                                    style={{ marginRight: '20px' }}
                                />
                                <FormControlLabel
                                    name='isPrimary'
                                    control={<Checkbox checked={Boolean(formData.isPrimary) || false} />}
                                    onChange={handleChangeCheckbox}
                                    label="Default"
                                />
                            </FormGroup>
                        </Grid>
                    </Grid>

                    <Grid container spacing={2} justifyContent="space-between" px={2}>
                        <Grid
                            item
                            container
                            justifyContent="flex-end"
                            alignItems="center"
                            spacing={2}
                        >
                            <Grid item>
                                <Button
                                    onClick={clear}
                                    variant="contained"
                                    color='secondary'
                                    startIcon={<RotateLeftIcon />}
                                >
                                    Reset
                                </Button>
                            </Grid>
                            <Grid item>
                                <Button
                                    onClick={handleSubmit}
                                    autoFocus
                                    variant="contained"
                                    color={isEdit ? 'success' : 'primary'}
                                    startIcon={isEdit ? <UpdateIcon /> : <SaveIcon />}
                                >
                                    {isEdit ? "Update" : "Save"}
                                </Button>
                            </Grid>
                        </Grid>
                    </Grid>
                </motion.div>
            }
        </>
    )
}

export default memo(CategoryCard);


